<template>
  <v-card class="header">
    <DealerUserDesktopNav
      v-if="$vuetify.breakpoint.width > 960"
      :dealerViewingUser="dealerViewingUser"
      :showDealerMyUsers="showDealerMyUsers"
      :navTabsOptional="navTabsOptional"
    />
    <DealerUserMobileNav
      v-else
      :dealerViewingUser="dealerViewingUser"
      :showDealerMyUsers="showDealerMyUsers"
      :navTabsOptional="navTabsOptional"
    />
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import DealerUserDesktopNav from './DealerUserDesktopNav.vue'
import DealerUserMobileNav from './DealerUserMobileNav.vue'

export default defineComponent({
  name: 'DealerUserNav',
  props: {
    dealerViewingUser: {
      type: Boolean,
      required: true,
    },
    showDealerMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DealerUserDesktopNav,
    DealerUserMobileNav,
  },
})
</script>
